import { render, staticRenderFns } from "./CreateProjectTemplate.vue?vue&type=template&id=8791beee&scoped=true&"
import script from "./CreateProjectTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateProjectTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectTemplate.vue?vue&type=style&index=0&id=8791beee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8791beee",
  null
  
)

export default component.exports